import { prefix } from "./newsdata";
export var productData = [
  {
    id: "ai",
    title: "微型嵌入式人工智能核心板",
    keyFeatures: ["Cube.AI", "丰富的接口", "小尺寸"],
    features: [
      {
        info: "Cortex-M4系列",
        subInfo: [],
      },
      {
        info: "支持Keras,TFLite,ONNX等深度学习框架",
        subInfo: [],
      },
      {
        info: "板载精准的基准源0.5%,VREF= 1.24V",
        subInfo: [],
      },
      {
        info: "支持FATFS文件系统",
        subInfo: [],
      },
      {
        info: "支持实时操作系统FreeRTOS,RT-Thread,zephyr",
        subInfo: [],
      },
      {
        info: "抗干扰能力强",
        subInfo: [],
      },
      {
        info: "支持RS-485,RS-232,I2C,USART,SPI,USB,I2S等总线",
        subInfo: [],
      },
      {
        info: "支持随机数生成",
        subInfo: [],
      },
    ],
    name: "coreBoard",
    details: [
      {
        input: `通过Vin引脚供电,+5~12V`,
        // model: `STM32G431CBT6`,
        // size: "43.2 mm * 19.06 mm",
        core: `ARM Cortex-M4`,
        flash: "128KB",
        RAM: "32KB | 22KB",
        pn: "ZZHY2023022301 | ZZHY2023022301F",
        max_freq: "170MHz",
        download: "ba14e59a-cff2-4627-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "3c2b6713-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cff2-4627-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: "4g",
    title: "LoRa-4G网关",
    keyFeatures: ["MQTT云端互连", "低功耗设计", "LoRa组网 "],
    features: [
      {
        info: "本地和云端灵活配置",
        subInfo: [],
      },
      {
        info: "定位：北斗/GPS/GLONASS/QZSS",
        subInfo: [],
      },
      {
        info: "内嵌实时操作系统",
        subInfo: [],
      },
      {
        info: "支持RS-485、RS-232、UART、I2C、SPI、USB2.0、模拟音频、数字音频、ADC",
        subInfo: [],
      },
      {
        info: "支持固件空中升级",
        subInfo: [],
      },
      {
        info: "支持屏幕显示",
        subInfo: [],
      },
    ],
    name: "gateway",
    details: [
      {
        type: "带外壳",
        // input: `内部电池供电或外部直流供电`,
        // fre_4g: "LTE-TDD：B34/B38/B39/B40/B41",
        // fre_lora: "470M～510MHz 或 860～930MHz",
        PN: "<div>带定位:ZZHY2024110706 | ZZHY2024110706F</div><div>不带定位:ZZHY2024110707 | ZZHY2024110707F</div>",
        // input: `内部电池供电 | 外部直流供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div><div>LoRa：470M～510MHz或860～930MHz</div>",
        size: "133mm * 75.89mm * 48.09mm",

        download: "ba14e59a-cff2-6666-99a5-19310964837b-01-cn",
      },
      {
        type: "不带外壳",
        // input: `内部电池供电或外部直流供电`,
        PN: "<div>带定位:ZZHY2024082401 | ZZHY2024082401F</div><div>不带定位:ZZHY2024082402 | ZZHY2024082402F</div>",
        // input: `内部电池供电 | 外部直流供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div><div>LoRa：470M～510MHz或860～930MHz</div>",
        size: "75mm × 50mm × 13mm",
        // fre_4g: "LTE-TDD：B34/B38/B39/B40/B41",
        // fre_lora: "470M～510MHz 或 860～930MHz",
        download: "ba14e59a-cff2-6666-99a5-19339864837b-01-cn",
      },
    ],
    img: [
      {
        // src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896www-03-xx.png",
        src: prefix + "3c2bwe13-b963-43c4-a8a0-73c3da796www-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: "xxwl",
    title: "小型物联网终端板",
    keyFeatures: [
      "支持WIFI和蓝牙",
      "内置六轴加速度和温湿度传感器",
      "支持USB Type-C",
    ],
    features: [
      {
        info: "主模块ESP32系列",
        subInfo: [],
      },
      {
        info: "支持UART,I2C,SPI等多种总线协议",
        subInfo: [],
      },
      {
        info: "支持OTA",
        subInfo: [],
      },
      {
        info: "支持通过USB,Type-C接口烧录程序",
        subInfo: [],
      },
      {
        info: "丰富的GPIO接口,共26个",
        subInfo: [],
      },
      {
        info: "可用于Web Server",
        subInfo: [],
      },
      {
        info: "支持实时操作系统FreeRTOS",
        subInfo: [],
      },
      {
        info: "良好的PCB设计使得天线发射和接收性能最佳",
        subInfo: [],
      },
    ],
    name: "neptune",
    details: [
      {
        input: `方式一:USB Type-C供电   方式二:Vin引脚5V供电 `,
        // model: `ESP32-WROOM-32`,
        flash: "4MB",
        SRAM: "520KB",
        pn: "ZZHY2022120901 | ZZHY2022120901F",
        download: "1c98b919-e5bb-4023-8f66-d77078708372-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "a9c6405d-d11e-438b-8ab7-c29be2cfa51c-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "1c98b919-e5bb-4023-8f66-d77078708372-01-cn",
    //   },
    // },
  },
  {
    id: "jyh",
    title: '"机遇号"物联网终端核心板',
    keyFeatures: [
      "强大的处理能力",
      "丰富的IO接口(136pins)",
      "内嵌物联网通信板",
    ],
    features: [
      {
        info: "Cortex-M4系列",
        subInfo: [],
      },
      {
        info: "支持Keras,TFLite,ONNX等深度学习框架",
        subInfo: [],
      },
      {
        info: "支持TFT屏幕显示",
        subInfo: [],
      },
      {
        info: "实时操作系统FreeRTOS,RT-Thread,zephyr",
        subInfo: [],
      },
      {
        info: "支持WIFI通信",
        subInfo: [],
      },
      {
        info: "丰富的GPIO接口(136pins)",
        subInfo: [],
      },
      {
        info: "支持RS-485,USART,I2C,SPI,USB等总线",
        subInfo: [],
      },
      {
        info: "7.2Msps ADC",
        subInfo: [],
      },
    ],
    name: "neptune",
    details: [
      {
        input: `+3.3V~+12V `,
        // model: `ESP32-WROOM-32`,
        flash: "1MB | 4Gb | 256Mb",
        RAM: "(256KB + 4KB) 256Mb",
        pn: "ZZHY2022120901 | ZZHY2022120901F",
        core: "ARM Cortex-M4",
        max_freq: "180MHz",
        download: "666040b9-1a64-4982-a246-91356ed928b9-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "a9c64123-d11e-438b-8ab7-c29be2cfa52a-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "666040b9-1a64-4982-a246-91356ed928b9-01-cn",
    //   },
    // },
  },
  {
    id: 3,
    title: "智慧物联网后台管理系统",
    keyFeatures: ["SCADA", "AI赋能", "云端控制"],
    features: [
      {
        info: "边缘计算和云计算的有机结合,AI算法实现推理和决策",
        subInfo: [],
      },
      {
        info: "云端算法投送,按需动态分配,助力边缘AI",
        subInfo: [],
      },
      {
        info: "数据库集群",
        subInfo: [],
      },
      {
        info: "自动化测试优化产品质量",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "c747d053-0baf-425e-8202-a72999054e7e-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "4b663419-4077-479f-9334-bf159509ecac-01-cn",
      },
    },
  },
  {
    id: 4,
    title: "数字天工-智慧工厂",
    keyFeatures: ["虚实结合", "数字孪生", "实时监测"],
    features: [
      {
        info: "虚实结合",
        subInfo: [],
      },
      {
        info: "数字孪生",
        subInfo: [],
      },
      {
        info: "实时监测",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "5d654ae2-8877-493e-b47e-be02d9f67a3b-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "379987fc-3663-46b2-a191-22d6d7b517c8-01-cn",
      },
    },
  },
  ///new !
  {
    id: 5,
    title: "4G终端",
    keyFeatures: ["边云协作", "宽温应用", "卫星定位"],
    features: [
      {
        info: "LTE Cat-1/TDD",
        subInfo: [],
      },
      {
        info: "工作温度:-30­°C~75­°C",
        subInfo: [],
      },
      {
        info: "加密传输",
        subInfo: [],
      },
      {
        info: "定位：北斗/GPS/GLONASS/QZSS",
        subInfo: [],
      },
      {
        info: "外壳IP65防水防尘",
        subInfo: [],
      },
      {
        info: "可支持定制国际物联网卡",
        subInfo: [],
      },
    ],
    name: "小型4G终端",
    details: [
      {
        type: "带外壳",
        PN: "<div>带定位:ZZHY2024110701 | ZZHY2024110701F</div><div>不带定位:ZZHY2024110702 | ZZHY2024110702F</div>",
        // input: `内部电池供电 | 外部直流供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div>",
        size: `133mm * 75.89mm * 48.09mm`,
        download: "163b6afa-a371-49c4-86de-48fafc847536-01-cn",
      },
      {
        type: "不带外壳",
        PN: "<div>带定位:ZZHY2023111101 | ZZHY2023111101F</div><div>不带定位:ZZHY2023111102 | ZZHY2023111102F</div>",
        // input: `5～12V供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div>",
        size: `45mm * 45mm * 9mm`,
        download: "163b6afa-a371-49c4-86de-48fafc847538-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "52672361-76cf-487a-9889-8f7f80ee1b3c-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "163b6afa-a371-49c4-86de-48fafc847536-01-cn",
    //   },
    // },
  },
  {
    id: 6,
    title: "NB-IoT终端",
    keyFeatures: ["边云协作", "宽温应用", "低功耗设计"],
    features: [
      {
        info: "5G NB-IoT",
        subInfo: [],
      },
      {
        info: "工作温度:-40­°C~85­°C",
        subInfo: [],
      },
      {
        info: "支持实时操作系统",
        subInfo: [],
      },
      {
        info: "支持固件空中升级",
        subInfo: [],
      },
      {
        info: "外壳IP65防水防尘",
        subInfo: [],
      },
      {
        info: "支持RS-485、I2C、SPI、ADC等",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧城市", "设备上云", "智慧工地"],
      },
      // {
      //   info: "频段：B5/B8",
      //   subInfo: [],
      // },
      // {
      //   info: "数据传输：Cat NB2速率：126kbps（DL）/ 158.5kbps（UL）",
      //   subInfo: [],
      // },
      // {
      //   info: "网络协议：MQTT / HTTP / TCP / UDP / CoAP / LwM2M / IPV6 / DTLS / DNS",
      //   subInfo: [],
      // },
    ],
    name: "NB-IoT终端",
    details: [
      {
        // type: "带外壳",
        PN: "<div>ZZHYNT001</div>",

        // input: `内部电池供电或外部直流供电`,
        fre: "B5/B8",
        size: `133mm * 75.89mm * 48.09mm`,
        download: "e701af55-15a7-4aab-bbcf-5c6031412fcc-01-cn",
        // core: "Cortex-M0+",
      },
      {
        type: "不带外壳",
        PN: "<div>ZZHYNT002</div>",

        // input: `方式一:5V供电   方式二:锂电池供电`,
        fre: "B5/B8",
        size: `25mm * 25mm * 6mm`,
        download: "e701af55-15a7-4aab-bbcf-5c6031412fcc-01-cn",
        // core: "Cortex-M0+",
      },
    ],
    img: [
      {
        // src: prefix + "52672361-76cf-487a-9889-8f7f80ee1b3c-03-xx.png",
        src: prefix + "1438f644-006e-46b6-b644-5078ae4122c3-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "e701af55-15a7-4aab-bbcf-5c6031412fcc-01-cn",
    //   },
    // },
  },
  {
    id: 7,
    title: "LoRa终端",
    keyFeatures: ["LPWAN", "低功耗设计", "宽温应用"],
    features: [
      {
        info: "低频段或高频段",
        subInfo: [],
      },
      {
        info: "工作温度:-40­°C~85­°C",
        subInfo: [],
      },
      {
        info: "外壳IP65防水防尘",
        subInfo: [],
      },
      {
        info: "加密传输",
        subInfo: [],
      },
      {
        info: "支持固件空中升级",
        subInfo: [],
      },
      {
        info: "自由组网",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧工厂", "智能消防"],
      },
    ],
    name: "IOTsystem",
    details: [
      {
        // type: "带外壳",
        // input: `内部电池供电或外部直流供电`,
        PN: "<div>ZZHYLT003</div>",
        size: `35mm * 35mm`,
        fre: "410M～510MHz或860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-cn",
        // core: "Cortex-M0+",
        // flash: "32KB",
        // RAM: "8KB",
        // maxPin: "32MHz",
        // eeprom: "1KB",
        // pn: "ZZHY2024110704 | WAU2023042601F",
      },
      {
        // type: "不带外壳",
        // input: `方式一:5~12V供电   方式二:锂电池供电`,
        PN: "<div>ZZHYLT004</div>",
        size: `30mm × 30mm`,
        fre: "410M～510MHz或860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-cn",

        // core: "Cortex-M0+",
      },
      {
        // type: "不带外壳",
        // input: `方式一:5~12V供电   方式二:锂电池供电`,
        PN: "<div>ZZHYLT005</div>",
        size: `30mm × 30mm`,
        fre: "410M～510MHz或860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-cn",

        // core: "Cortex-M0+",
      },
      {
        // type: "不带外壳",
        // input: `方式一:5~12V供电   方式二:锂电池供电`,
        PN: "<div>ZZHYLT006</div>",
        size: `Φ34mm`,
        fre: "410M～510MHz或860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-cn",

        // core: "Cortex-M0+",
      },
    ],
    img: [
      {
        src: prefix + "1e9b6567-f715-4db9-bc4e-4f443ba6e6a8-03-xx.png",
        // src: prefix + "52672361-76cf-487a-9889-8f7f80ee1b3c-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-cn",
    //   },
    // },
  },
  // 机器视觉
  {
    id: 8,
    title: "安防应用",
    keyFeatures: [],
    features: [
      {
        info: "安全帽、安全衣检测",
        subInfo: [],
      },
      {
        info: "明火检测",
        subInfo: [],
      },
      {
        info: "人脸识别",
        subInfo: [],
      },
      {
        info: "人形识别",
        subInfo: [],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "46fa6615-ab74-4df3-a6c4-3050338244e6-03-xx.png",
      },
    ],
    // download: "",
    download: {
      cn: {
        file_code: "",
      },
    },
  },
  {
    id: 9,
    title: "工业检测",
    keyFeatures: [],
    features: [
      {
        info: "产品外观不良检测",
        subInfo: ["高精度", "稳定", "实时"],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "0e16b67f-853e-4571-9139-123231f4298f-03-xx.png",
      },
    ],
    // download: "",
    download: {
      cn: {
        file_code: "",
      },
    },
  },
  {
    id: 10,
    title: "TurMass™终端",
    keyFeatures: ["低功耗广域网", "全国产方案", "宽温应用 "],
    features: [
      {
        info: "基于道生物联全国产终端模组设计",
        subInfo: [],
      },
      {
        info: "自由频段",
        subInfo: [],
      },
      {
        info: "加密传输",
        subInfo: [],
      },
      {
        info: "RISC-V内核",
        subInfo: [],
      },
      {
        info: "工作温度:-40­°C~85­°C",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧铁塔", "海洋监测"],
      },
      {
        info: "注:TurMass™为上海道生物联技术有限公司的商标",
        subInfo: [],
      },
    ],
    name: "gateway",
    details: [
      {
        // input: `内部电池供电或外部直流供电`,
        PN: "<div>ZZHYTT001</div>",
        fre: "低频(470MHz~510MHz)或高频(863MHz~928MHz)",
        size: "30mm * 30mm",
        // rate: "0.441kbps~85.106kbps",
        // distance: "户外测试:4.2 千米",
        download: "ba14e59a-cff2-1234-99a5-19310964837b-01-cn",
      },
      {
        // input: `内部电池供电或外部直流供电`,
        PN: "<div>ZZHYTT002</div>",
        fre: "低频(470MHz~510MHz)或高频(863MHz~928MHz)",
        size: "133mm * 76mm * 48mm",

        // rate: "0.441kbps~85.106kbps",
        // distance: "户外测试:4.2 千米",
        download: "ba14e59a-cff2-1234-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        // src: prefix + "52672361-76cf-487a-9889-8f7f80ee1b3c-03-xx.png",
        src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cff2-1234-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 11,
    title: "TurMass™边缘网关",
    keyFeatures: ["异构协作", "自由组网", "多种方式入网 "],
    features: [
      {
        info: "私有网转公网方式：4G,以太网",
        subInfo: [],
      },
      {
        info: "支持高并发",
        subInfo: [],
      },
      {
        info: "防水防盐雾定制设计",
        subInfo: [],
      },
      {
        info: "定制算法",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["化工领域", "智能制造", "智慧铁塔"],
      },
      {
        info: "注:TurMass™为上海道生物联技术有限公司的商标",
        subInfo: [],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `100~240VAC交流供电`,
        size: "133mm * 75.89mm * 48.09mm",
        fre: "<div>4G：LTE-TDD：B34/B38/B39/B40/B41；</div> <div>4G：LTE-FDD：B1/B3/B5/B8；</div> <div>TurMass：低频(470MHz~510MHz)或高频(863MHz~928MHz)</div>",
        download: "ba14e59a-cdd2-6789-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896www-03-xx.png",
        // src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cdd2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 12,
    title: "LoRa边缘网关",
    keyFeatures: ["异构协作", "自由组网", "宽温应用 "],
    features: [
      {
        info: "低频段或高频段",
        subInfo: [],
      },
      {
        info: "私有网转公网方式：以太网",
        subInfo: [],
      },
      {
        info: "加密传输",
        subInfo: [],
      },
      {
        info: "内嵌实时操作系统",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧工厂", "海洋监测"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `AC:220VAC`,
        size: "133mm * 75.89mm * 48.09mm",
        netrate: "10/100M",
        // fre: "LoRa：410M～525MHz 或 860～930MHz",
        LoRa_Receive_Sensitivity: "LoRa：-137 dBm@SF10 125KHz",
        download: "dn14e59a-cff2-6666-99a5-193109ag837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-abcd-73c324566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },

  {
    id: 13,
    title: "边缘处理终端",
    keyFeatures: ["边云协同", "高精度定位", "数据处理", "防水设计"],
    features: [
      {
        info: "4G LTE Cat-1 全网通",
        subInfo: [],
      },
      {
        info: "标配米级定位精度;高配版可支持分米到厘米级定位精度",
        subInfo: [],
      },
      {
        info: "RS485,4~20mA检测,CAN总线接口",
        subInfo: [],
      },
      {
        info: "内含六轴IMU和温湿度传感器",
        subInfo: [],
      },
      {
        info: "低功耗设计",
        subInfo: [],
      },
      {
        info: "防水防尘",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧城市", "智慧农业", "智慧电力", "设备上云"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・内部电池供电</div>  <div>・外部+12V供电</div>  <div>・外部太阳能板供电</div>`,
        size: "158mm * 91mm * 56mm",
        rate_4g:
          "<div>・LTE-TDD速率：Max. 7.5Mbps(DL)/Max. 1Mbps(UL)</div> <div>・LTE-FDD速率：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cff2-6666-99a5-193109648399-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324499e10-03-xx.png",
      },
    ],
  },
  {
    id: 14,
    title: "4G语音终端Ⅱ",
    keyFeatures: ["语音交互", "超低功耗", "定位", "防水设计"],
    features: [
      {
        info: "语音交互，可接打电话",
        subInfo: [],
      },
      {
        info: "定位精度：2米",
        subInfo: [],
      },
      {
        info: "户外防水设计",
        subInfo: [],
      },
      {
        info: "内含六轴IMU和地磁传感器",
        subInfo: [],
      },
      {
        info: "低功耗设计",
        subInfo: [],
      },
      {
        info: "小尺寸",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧工地", "智慧电力", "安全帽", "园区定位"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・内部电池供电</div>  <div>・外部USB Type-C供电</div>`,
        size: "38mm * 38mm * 18mm",
        rate_4g:
          "<div>・LTE-TDD速率：Max. 8.96Mbps(DL)/Max. 3.1Mbps(UL)</div> <div>LTE-FDD速率：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e5w3-cff2-6666-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c664566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 16,
    title: "电参数监测电源线",
    keyFeatures: ["~10A/16A电流", "高精度", "小尺寸"],
    features: [
      {
        info: "LTE Cat-1",
        subInfo: [],
      },
      {
        info: "高精度",
        subInfo: [],
      },
      {
        info: "3C认证",
        subInfo: [],
      },
      {
        info: "C13-C14/C19-C20类型",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["设备管理", "数据中心", "智慧医院"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>100~240 VAC市电</div>`,
        size: "50cm",
        rate_4g: "<div>LTE-TDD速率：Max. 7.5Mbps(DL)/Max. 1Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e88a-cff2-6666-89a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 17,
    title: "边缘处理终端（小型）",
    keyFeatures: ["边云协同", "高精度定位", "语音分析"],
    features: [
      {
        info: "LTE Cat-1 全网通",
        subInfo: [],
      },
      {
        info: "标配米级定位精度;高配版可支持分米到厘米级定位精度",
        subInfo: [],
      },
      {
        info: "3C认证",
        subInfo: [],
      },
      {
        info: "RS485,音频(可外接拾音器)",
        subInfo: [],
      },
      {
        info: "内含六轴IMU和温湿度传感器",
        subInfo: [],
      },
      {
        info: "低功耗设计",
        subInfo: [],
      },
      {
        info: "磁吸安装或粘胶安装",
        subInfo: [],
      },
      {
        info: "应用领域",
        subInfo: ["智慧工地", "设备上云"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・内部电池供电</div>  <div>・USB Type-C外部供电</div>`,
        size: "100mm *62mm *18mm",
        rate_4g:
          "<div>・LTE-TDD速率：Max. 7.5Mbps(DL)/Max. 1Mbps(UL)</div> <div>・LTE-FDD速率：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cff2-7766-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 18,
    title: "4G语音终端Ⅰ",
    keyFeatures: ["语音交互", "长待机", "小尺寸"],
    features: [
      {
        info: "语音交互,接打电话",
        subInfo: [],
      },
      {
        info: "定位精度：2米",
        subInfo: [],
      },
      {
        info: "低功耗设计",
        subInfo: [],
      },
      {
        info: "内含六轴IMU和地磁传感器",
        subInfo: [],
      },
      {
        info: "小尺寸",
        subInfo: [],
      },

      {
        info: "应用领域",
        subInfo: ["智慧工地", "智慧电力", "园区定位"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・内部电池供电</div>  <div>・USB Type-C外部供电</div>`,
        size: "60mm *97mm *12mm",
        rate_4g:
          "<div>・LTE-TDD速率：Max. 8.96Mbps(DL)/Max. 3.1Mbps(UL)</div> <div>・LTE-FDD速率：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cdd2-6666-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "4412313-b963-43c4-a8a0-73c324566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 19,
    title: "电流监测无线终端",
    keyFeatures: ["~100A/120A/150A/200A", "高精度", "低功耗设计"],
    features: [
      {
        info: "精度高",
        subInfo: [],
      },
      {
        info: "长寿命",
        subInfo: [],
      },
      {
        info: "可升级支持WiFi6",
        subInfo: [],
      },

      {
        info: "应用领域",
        subInfo: ["电力物联网", "设备管理", "智慧医院"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>内部电池供电（19000mAh）</div>`,
        size: "43mm *43mm *136mm",
        // rate_4g:
        //   "<div>・LTE-TDD速率：Max. 8.96Mbps(DL)/Max. 3.1Mbps(UL)</div> <div>・LTE-FDD速率：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>2.4GHz</div> ",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cff2-diw6-99a5-19310964837b-01-cn",
      },
    ],
    img: [
      {
        src: prefix + "219bwe13-b963-43c4-a8a0-73c324566e83-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
];

export var serviceData = [
  {
    id: 1,
    title: "电路设计",
    keyFeatures: [],
    features: [
      {
        info: "模拟/数字电路设计,PCB Layout,样品制作,包括：",
        subInfo: [
          "嵌入式系统(含通信模块)",
          "AC/DC电源,DC/DC电源",
          "锂电池储能系统",
        ],
      },
      {
        info: "三维系统建模",
        subInfo: [],
      },
      {
        info: "高性价比,可量产的BOM物料",
        subInfo: [],
      },
      {
        info: "第三方测试认证服务(EMC、Safety和可靠性)",
        subInfo: [],
      },
      {
        info: "高密度,小型化设计",
        subInfo: [],
      },
    ],
    name: "dianlu",
    details: [],
    img: [
      {
        src: prefix + "5b46c30d-4b0b-410b-b824-1281e3112aba-03-xx.jpg",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-cn",
      },
    },
  },
  {
    id: 2,
    title: "嵌入式软件开发",
    keyFeatures: [],
    features: [
      {
        info: "ARM Cortex-M系列(例如:STM32),包括:",
        subInfo: [
          "ADC/DAC",
          "UART,I2C,SPI,CAN,RS-232,RS-485,USB等各种总线通信",
          "实时操作系统FreeRTOS,RT-Thread等",
          "FATFS文件系统",
        ],
      },
      {
        info: "ARM Cortex-A系列",
        subInfo: [],
      },
      {
        info: "电池BMS算法",
        subInfo: [],
      },
      {
        info: "轻量化深度神经网络开发",
        subInfo: [],
      },
      {
        info: "固件空中升级（FOTA）",
        subInfo: [],
      },
    ],
    name: "neptune",
    details: [],
    img: [
      {
        src: prefix + "6faa16f6-bf6f-483d-afc1-6c39ef1261a9-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-cn",
      },
    },
  },
  {
    id: 3,
    title: "机械设计",
    keyFeatures: [],
    features: [
      {
        info: "ID设计",
        subInfo: [],
      },
      {
        info: "整机设计",
        subInfo: [],
      },
      {
        info: "2D/3D结构图",
        subInfo: [],
      },
      {
        info: "堆叠",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "c747d053-0baf-425e-8202-a72999054e6e-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-cn",
      },
    },
  },
  {
    id: 4,
    title: "桌面应用软件开发",
    keyFeatures: ["跨平台", "支持多种通信协议BLE、WIFI等", "实时波形图"],
    features: [
      {
        info: "跨平台（Windows、Linux、MacOs）",
        subInfo: [],
      },
      {
        info: "AI算法加持",
        subInfo: [],
      },
      {
        info: "模块自由加减",
        subInfo: [],
      },
      {
        info: "自适应布局",
        subInfo: [],
      },
      {
        info: "支持多种通信协议（BLE、WIFI等）",
        subInfo: [],
      },
      {
        info: "内嵌数据库",
        subInfo: [],
      },
      {
        info: "精美的UI设计",
        subInfo: [],
      },
      {
        info: "自动生成报表（PDF、Word、Excel等）",
        subInfo: [],
      },
      {
        info: "OTA升级",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "777c112b-83ca-4acf-8a98-4947ab5524da-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "91dc746c-3c01-437e-a6e1-e1ddc932d9ce-01-cn",
      },
    },
  },
  {
    id: 5,
    title: "前端开发",
    keyFeatures: [
      "前端开发",
      "数据大屏",
      "UIUE设计",
      "H5页面",
      "APP",
      "小程序",
    ],
    features: [
      {
        info: "实时性",
        subInfo: [],
      },
      {
        info: "全方位",
        subInfo: [],
      },
      {
        info: "GIS定位",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "7d0dd728-23fa-4e01-9e94-234809b8be78-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "a73372b9-7df0-46bc-b989-00131aa87380-01-cn",
      },
    },
  },
  {
    id: 6,
    title: "数据分析",
    keyFeatures: [],
    features: [
      {
        info: "数理统计",
        subInfo: [],
      },
      {
        info: "数据建模",
        subInfo: [],
      },
      {
        info: "数据挖掘",
        subInfo: [],
      },
      {
        info: "机器学习",
        subInfo: [],
      },
      {
        info: "大数据分析",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "4c40bf6d-c04e-4249-a032-e46e211bab3c-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "a73372b9-7df0-46bc-b989-00131aa87380-01-cn",
      },
    },
  },
  {
    id: 7,
    title: "边缘计算网关",
    keyFeatures: ["AI计算", "边云协同", "高可靠性"],
    features: [
      {
        info: "AI算力",
        subInfo: [],
      },
      {
        info: "Linux系统",
        subInfo: [],
      },
      {
        info: "支持主流目标检测和图像识别算法",
        subInfo: [],
      },
      {
        info: "云端算法投送",
        subInfo: [],
      },
      {
        info: "4G、5G、Zigbee、LoRa",
        subInfo: [],
      },
      {
        info: "支持业内主流深度学习计算框架",
        subInfo: [],
      },
      {
        info: "支持Docker部署",
        subInfo: [],
      },
      {
        info: "任务编排",
        subInfo: [],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "4c40bf6d-c04e-4249-a032-e46e211www3c-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "0e9040b9-1a64-4982-a246-91356ed928b9-01-cn",
      },
    },
  },
  {
    id: 8,
    title: "人机交互设计",
    keyFeatures: [],
    features: [
      {
        info: "串口屏和SPI屏",
        subInfo: [],
      },
      {
        info: "UI、UE",
        subInfo: [],
      },
      {
        info: "组态开发",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "c747d053-0baf-425e-8202-a729dc054e6e-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-cn",
      },
    },
  },
];

export var productData_en = [
  {
    id: "ai",
    title: "Mini Embedded AI Coreboard",
    keyFeatures: ["Cube.AI", "Rich interfaces", "Small Footprint"],
    features: [
      {
        info: "Cortex-M4 series",
        subInfo: [],
      },
      {
        info: "Support deep learning frameworks such as Keras, TFLite, ONNX",
        subInfo: [],
      },
      {
        info: "On-board precise reference source 0.5%,VREF = 1.24V",
        subInfo: [],
      },
      {
        info: "FATFS file system",
        subInfo: [],
      },
      {
        info: "Support real-time operating systems FreeRTOS, RT-Thread,zephyr",
        subInfo: [],
      },
      {
        info: "Electromagnetic Immunity",
        subInfo: [],
      },
      {
        info: "RS-485, RS-232, I2C, USART, SPI, USB, I2S and other buses",
        subInfo: [],
      },
      {
        info: "Random number generation",
        subInfo: [],
      },
    ],
    name: "coreBoard",
    details: [
      {
        input: `Powered by Vin pin, +5~12V`,
        // model: `STM32G431CBT6`,
        // size: "43.2 mm * 19.06 mm",
        core: `ARM Cortex-M4`,
        flash: "128KB",
        RAM: "32KB | 22KB",
        size: "43.2 mm * 19.06 mm",

        pn: "ZZHY2023022301 | ZZHY2023022301F",
        max_freq: "170MHz",
        download: "ba14e59a-cff2-4627-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "3c2b6713-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cff2-4627-99a5-19310964837b-01-en",
    //   },
    // },
  },
  {
    id: 12,
    title: "LoRa Edge Gateway",
    keyFeatures: [
      "Heterogeneous Collaboration",
      "Free Networking",
      "Wide Temperature Applications",
    ],
    features: [
      {
        info: "Low band or high band",
        subInfo: [],
      },
      {
        info: "Embedded real-time operating system ",
        subInfo: [],
      },
      {
        info: "Encrypted transmission",
        subInfo: [],
      },
      {
        info: "Private to public mode: Ethernet",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Smart Factory", "Marine Monitoring"],
      },
      // {
      //   info: "Support SD card local storage",
      //   subInfo: [],
      // },
    ],
    name: "gateway",
    details: [
      {
        // type: "with shell",
        // input: `Internal battery power or external DC power`,
        // size: "133mm * 75.89mm * 48.09mm",
        // fre_4g: "LTE-TDD：B34/B38/B39/B40/B41",
        // fre_lora: "470M～510MHz or 860～930MHz",
        PN: "<div>ZZHYLEGW001</div>",
        // input: `内部电池供电 | 外部直流供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div><div>LoRa：470M～510MHz or 860～930MHz</div>",
        size: "133mm * 76mm * 48mm",

        download: "ba14e59a-cff2-6666-99a5-19310964837b-01-en",
      },
      // {
      //   type: "without shell",
      //   // input: `Internal battery power or external DC power`,
      //   // size: "133mm * 75.89mm * 48.09mm",
      //   // fre_4g: "LTE-TDD：B34/B38/B39/B40/B41",
      //   // fre_lora: "470M～510MHz or 860～930MHz",
      //   PN: "<div>with locator:ZZHY2024082401 | ZZHY2024082401F</div><div>without locator:ZZHY2024082402 | ZZHY2024082402F</div>",
      //   // input: `内部电池供电 | 外部直流供电`,
      //   fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div><div>LoRa：470M～510MHz or 860～930MHz</div>",
      //   size: "75mm × 50mm × 13mm",
      //   // fre_4g: "LTE-TDD：B34/B38/B39/B40/B41",
      //   // fre_lora: "470M～510MHz 或 860～930MHz",
      //   download: "ba14e59a-cff2-6666-99a5-19339864837b-01-en",
      // },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-abcd-73c324566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cff2-6666-99a5-19310964837b-01-en",
    //   },
    // },
  },
  {
    id: "xxwl",
    title: "Small IoT Terminal Board",
    keyFeatures: [
      "WIFI and Bluetooth",
      "Built-in six-axis acceleration、temperature and humidity sensors",
      "USB Type-C",
    ],
    features: [
      {
        info: "Main module: ESP32 series",
        subInfo: [],
      },
      {
        info: "Supports multiple bus protocols,such as UART, I2C, SPI",
        subInfo: [],
      },
      {
        info: "OTA",
        subInfo: [],
      },
      {
        info: "Burning program via USB Type-C interface",
        subInfo: [],
      },
      {
        info: "Rich GPIO interfaces, a total of 26",
        subInfo: [],
      },
      {
        info: "Can be used for Web Server",
        subInfo: [],
      },
      {
        info: "Real-time operating system FreeRTOS",
        subInfo: [],
      },
      {
        info: "Good PCB design makes the antenna Optimal transmit and receive performance",
        subInfo: [],
      },
    ],
    name: "neptune",
    details: [
      {
        input: `Methods 1: USB Type-C power supply   
        Methods 2: Vin pin 5V power supply   `,
        model: `ESP32-WROOM-32`,
        flash: "4MB",
        SRAM: "520KB",
        pn: "ZZHY2022120901 | ZZHY2022120901F",
        download: "1c98b919-e5bb-4023-8f66-d77078708372-01-en",
      },
    ],
    img: [
      {
        src: prefix + "a9c6405d-d11e-438b-8ab7-c29be2cfa51c-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "1c98b919-e5bb-4023-8f66-d77078708372-01-en",
    //   },
    // },
  },
  {
    id: "jyh",
    title: '"Opportunity" IoT terminal core boards',
    keyFeatures: [
      "powerful processing capabilities",
      "Rich IO interface (136pins)",
      "Embedded IoT communication board",
    ],
    features: [
      {
        info: "Cortex-M4 series",
        subInfo: [],
      },
      {
        info: "Support Keras, TFLite, ONNX and other deep learning frameworks",
        subInfo: [],
      },
      {
        info: "Support TFT screen",
        subInfo: [],
      },
      {
        info: "Real-time operating system FreeRTOS,RT-Thread,zephyr",
        subInfo: [],
      },
      {
        info: "Supports WIFI",
        subInfo: [],
      },
      {
        info: "Rich IO interface (136pins)",
        subInfo: [],
      },
      {
        info: "Support RS-485, USART, I2C, SPI, USB and other buses.",
        subInfo: [],
      },
      {
        info: "7.2Msps ADC",
        subInfo: [],
      },
    ],
    name: "neptune",
    details: [
      {
        input: `+3.3V~+12V `,
        // model: `ESP32-WROOM-32`,
        flash: "1MB | 4Gb | 256Mb",
        RAM: "(256KB + 4KB) 256Mb",
        pn: "ZZHY2022120901 | ZZHY2022120901F",
        core: "ARM Cortex-M4",
        max_freq: "180MHz",
        download: "666040b9-1a64-4982-a246-91356ed928b9-01-en",
      },
    ],
    img: [
      {
        src: prefix + "a9c64123-d11e-438b-8ab7-c29be2cfa52a-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "666040b9-1a64-4982-a246-91356ed928b9-01-en",
    //   },
    // },
  },

  {
    id: 3,
    title: "Intelligent IOT Console System",
    keyFeatures: ["Real-time data", "AI", "Database clustering"],
    features: [
      {
        info: "The organic combination of edge computing and cloud computing, AI algorithms to achieve reasoning and decision-making.",
        subInfo: [],
      },
      {
        info: "Cloud algorithm delivery,on-demand dynamic distribution, to help edge AI.",
        subInfo: [],
      },
      {
        info: "Database clustering",
        subInfo: [],
      },
      {
        info: "Automated testing to optimise product quality",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [
      {
        input: `方式一:USB Type-C供电; 方式二:Vin引脚5V供电`,
        model: `ESP32-WROOM-32`,
        flash: "4MB",
        SRAM: "520KB",
      },
    ],
    img: [
      {
        src: prefix + "c747d053-0baf-425e-8202-a72999054e7e-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "4b663419-4077-479f-9334-bf159509ecac-01-en",
      },
    },
  },
  {
    id: 4,
    title: "Digital Skyworks-Smart Factory",
    keyFeatures: [
      "Combination of reality and imagination",
      "Digital Interpretation",
      "AI Empowerment",
    ],
    features: [
      {
        info: "Combination of reality and imagination",
        subInfo: [],
      },
      {
        info: "Digital Interpretation",
        subInfo: [],
      },
      {
        info: "AI Empowerment",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "5d654ae2-8877-493e-b47e-be02d9f67a3b-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "379987fc-3663-46b2-a191-22d6d7b517c8-01-en",
      },
    },
  },
  ///new !
  {
    id: 5,
    title: "4G Terminal",
    keyFeatures: [
      "Edge-cloud collaboration",
      "Wide Temperature Applications",
      "Satellite Positioning",
    ],
    features: [
      {
        info: "LTE Cat-1/TDD",
        subInfo: [],
      },
      {
        info: "Working temperature:-30°C~75°C",
        subInfo: [],
      },
      {
        info: "encrypted transmission",
        subInfo: [],
      },
      {
        info: "Positioning: BeiDou/GPS/GLONASS/QZSS",
        subInfo: [],
      },
      {
        info: "Shell:IP65 waterproof and dustproof",
        subInfo: [],
      },
      {
        info: "Customised IoT cards can be supported",
        subInfo: [],
      },
    ],
    name: "小型4G终端",
    details: [
      // {
      //   input: `Internal battery power | External DC power`,
      //   size: `133mm * 75.89mm * 48.09mm`,
      // },
      {
        type: "with shell",
        PN: "<div>with locator:ZZHY2024110701 | ZZHY2024110701F</div><div>without locator:ZZHY2024110702 | ZZHY2024110702F</div>",
        // input: `内部电池供电 | 外部直流供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div>",
        size: `133mm * 75.89mm * 48.09mm`,
        download: "163b6afa-a371-49c4-86de-48fafc847536-01-en",
      },
      {
        type: "without shell",
        PN: "<div>with locator:ZZHY2023111101 | ZZHY2023111101F</div><div>without locator:ZZHY2023111102 | ZZHY2023111102F</div>",
        // input: `5～12V供电`,
        fre: "<div>4G:LTE-TDD：B34/B38/B39/B40/B41</div>",
        size: `45mm * 45mm * 9mm`,
        download: "163b6afa-a371-49c4-86de-48fafc847538-01-en",
      },
    ],
    img: [
      {
        src: prefix + "52672361-76cf-487a-9889-8f7f80ee1b3c-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "163b6afa-a371-49c4-86de-48fafc847536-01-en",
    //   },
    // },
  },
  {
    id: 6,
    title: "NB-IoT Terminal",
    keyFeatures: [
      "Side-cloud Collaboration",
      "Wide Temperature Applications",
      "Low-power Design",
    ],
    features: [
      {
        info: "5G NB-IoT",
        subInfo: [],
      },
      {
        info: "Working temperature:-40°C~85°C",
        subInfo: [],
      },
      {
        info: "Support for real-time operating systems",
        subInfo: [],
      },

      {
        info: "Supports OTA",
        subInfo: [],
      },
      {
        info: `Shell:IP65 waterproof and dustproof`,
        subInfo: [],
      },

      {
        info: "Support RS-485, I2C, SPI, ADC, etc",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Smart City", "Device connect to Cloud", "Smart Site"],
      },
      // {
      //   info: "Firmware over-the-air upgrade",
      //   subInfo: [],
      // },
      // {
      //   info: "Frequency band：B5/B8",
      //   subInfo: [],
      // },
      // {
      //   info: "Data transfer：Cat NB2 Rate：126kbps（DL）/ 158.5kbps（UL）",
      //   subInfo: [],
      // },
      // {
      //   info: "Network protocols：MQTT / HTTP / TCP / UDP / CoAP / LwM2M / IPV6 / DTLS / DNS",
      //   subInfo: [],
      // },
    ],
    name: "微型NB-IoT终端",
    details: [
      // {
      //   input: `Internal battery power | External DC power`,
      //   fre: "B5/B8",
      //   size: `133mm * 75.89mm * 48.09mm`,
      //   // core: "Cortex-M0+",
      //   // flash: "32KB",
      //   // RAM: "8KB",
      //   // maxPin: "32MHz",
      //   // eeprom: "1KB",
      //   // pn: "ZZHY2024110703 | WAU2023060602F",
      // },
      {
        // type: "with shell",
        PN: "<div>ZZHYNT001</div>",

        // input: `内部电池供电或外部直流供电`,
        fre: "B5/B8",
        size: `25mm * 25mm`,
        download: "e701af55-15a7-4aab-bbcf-5c6031412fcc-01-en",
        // core: "Cortex-M0+",
      },
      {
        // type: "without shell",
        PN: "<div>ZZHYNT002</div>",

        // input: `方式一:5V供电   方式二:锂电池供电`,
        fre: "B5/B8",
        size: `133mm * 76mm * 48mm`,
        download: "e701af55-15a7-4aab-bbcf-5c6031412fdd-01-en",
        // core: "Cortex-M0+",
      },
    ],
    img: [
      {
        src: prefix + "1438f644-006e-46b6-b644-5078ae4122c3-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "e701af55-15a7-4aab-bbcf-5c6031412fcc-01-en",
    //   },
    // },
  },
  {
    id: 7,
    title: "LoRa Terminal",
    keyFeatures: ["LPWAN", "Low-power Design", "Wide temperature applications"],
    features: [
      {
        info: "Low or high frequency band",
        subInfo: [],
      },
      {
        info: "Operating Temperature:-40°C~85°C",
        subInfo: [],
      },
      {
        info: `Free networking`,
        subInfo: [],
      },
      {
        info: `Encrypted transmission`,
        subInfo: [],
      },
      {
        info: "Support OTA",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Smart Factory", "Intelligent Fire Fighting"],
      },
    ],
    name: "IOTsystem",
    details: [
      // {
      //   input: `Internal battery power or external DC power`,
      //   size: `133mm * 75.89mm * 48.09mm`,
      //   fre: "410M～510MHz或860MHz～930MHz",

      //   // core: "Cortex-M0+",
      //   // flash: "32KB",
      //   // RAM: "8KB",
      //   // maxPin: "32MHz",
      //   // eeprom: "1KB",
      //   // pn: "ZZHY2024110704 | WAU2023042601F",
      // },
      {
        // type: "with shell",
        // input: `内部电池供电或外部直流供电`,
        PN: "<div>ZZHYLT003</div>",
        size: `35mm*35mm`,
        fre: "410M～510MHz or 860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-en",
        // core: "Cortex-M0+",
        // flash: "32KB",
        // RAM: "8KB",
        // maxPin: "32MHz",
        // eeprom: "1KB",
        // pn: "ZZHY2024110704 | WAU2023042601F",
      },
      {
        // type: "without shell",
        // input: `方式一:5~12V供电   方式二:锂电池供电`,
        PN: "<div>ZZHYLT004</div>",
        size: `30mm × 30mm`,
        fre: "410M～510MHz or 860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afff-01-en",

        // core: "Cortex-M0+",
      },
      {
        // type: "without shell",
        // input: `方式一:5~12V供电   方式二:锂电池供电`,
        PN: "<div>ZZHYLT005</div>",
        size: `30mm × 30mm`,
        fre: "410M～510MHz or 860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afff-01-en",

        // core: "Cortex-M0+",
      },
      {
        // type: "without shell",
        // input: `方式一:5~12V供电   方式二:锂电池供电`,
        PN: "<div>ZZHYLT006</div>",
        size: `Φ34mm`,
        fre: "410M～510MHz or 860MHz～930MHz",
        download: "58e893f1-dd71-40a2-8f84-5a11e4c0afff-01-en",

        // core: "Cortex-M0+",
      },
    ],
    img: [
      {
        src: prefix + "1e9b6567-f715-4db9-bc4e-4f443ba6e6a8-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "58e893f1-dd71-40a2-8f84-5a11e4c0afee-01-en",
      },
    },
  },
  //机器视觉
  {
    id: 8,
    title: "Security Applications",
    keyFeatures: [],
    features: [
      {
        info: "Safety Helmet/Vest Detection",
        subInfo: [],
      },
      {
        info: "Flame Detection",
        subInfo: [],
      },
      {
        info: "Face Detection",
        subInfo: [],
      },
      {
        info: "Person Detection",
        subInfo: [],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "46fa6615-ab74-4df3-a6c4-3050338244e6-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "",
      },
    },
  },
  {
    id: 9,
    title: "Industrial Inspection",
    keyFeatures: [],
    features: [
      {
        info: "Cosmetic Defects Detection",
        subInfo: ["High Precision", "Stability", "Real-Time Application"],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "0e16b67f-853e-4571-9139-123231f4298f-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "",
      },
    },
  },
  {
    id: 10,
    title: "TurMass™ Terminal",
    keyFeatures: [
      "Wide Temperature Applications",
      "Low Power WAN",
      "National Solutions",
    ],
    features: [
      {
        info: "Module design by TaoLink",
        subInfo: [],
      },
      {
        info: "Free band",
        subInfo: [],
      },
      {
        info: "Encrypted transmission",
        subInfo: [],
      },
      {
        info: "Core: RISC-V",
        subInfo: [],
      },
      {
        info: "Operating temperature:-40°C~85°C",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Smart Tower", "Marine Monitoring"],
      },
      {
        info: "note:TurMass™ is a trademark of Shanghai TAOLINK Technology Co.",
        subInfo: [],
      },
    ],
    name: "gateway",
    details: [
      // {
      //   input: `Internal battery power | External DC power`,
      //   size: "133mm * 75.89mm * 48.09mm",
      //   fre: "Low frequency (470MHz~510MHz) or high frequency (863MHz~928MHz)",
      //   rate: "0.441kbps~85.106kbps",
      //   // distance: "Outdoor test: 4.2 kilometres",
      // },
      {
        // input: `内部电池供电或外部直流供电`,
        // type: "with shell",
        PN: "<div>ZZHYTT001</div>",
        // fre: "low(470MHz~510MHz)or high(863MHz~928MHz)",
        size: "30mm * 30mm",
        // rate: "0.441kbps~85.106kbps",
        // distance: "户外测试:4.2 千米",
        download: "ba14e59a-cff2-1234-99a5-19310964837b-01-en",
      },
      {
        // input: `内部电池供电或外部直流供电`,
        // type: "without shell",
        PN: "<div>ZZHYTT002</div>",
        // fre: "low(470MHz~510MHz)or high(863MHz~928MHz)",
        size: "133mm * 76mm * 48mm",

        // rate: "0.441kbps~85.106kbps",
        // distance: "户外测试:4.2 千米",
        download: "ba14e59a-cff2-1234-66a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "52672361-76cf-487a-9889-8f7f80ee1b3c-03-xx.png",
        // src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cff2-1234-99a5-19310964837b-01-en",
    //   },
    // },
  },
  {
    id: 11,
    title: "TurMass™ Edge Gateway",
    keyFeatures: [
      "Heterogeneous Collaboration",
      "Free Networking",
      "Multiple ways to access the network",
    ],
    features: [
      {
        info: "Private to public network method: 4G, Ethernet",
        subInfo: [],
      },
      {
        info: "Supports high concurrency",
        subInfo: [],
      },
      {
        info: "Waterproof and salt spray resistant design",
        subInfo: [],
      },
      {
        info: "Customised algorithms",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: [
          "Chemical Industry",
          "Intelligent Tower",
          "Intelligent Manufacturing ",
        ],
      },
      {
        info: "note:TurMass™ is a trademark of Shanghai TAOLINK Technology Co.",
        subInfo: [],
      },
    ],
    name: "gateway",
    details: [
      // {
      //   input: `external power supply（5~15V）`,
      //   size: "133mm * 75.89mm * 48.09mm",
      //   fre: `4G：LTE-TDD：B34/B38/B39/B40/B41
      //   TurMass：Low frequency (470MHz~510MHz) or high frequency`,
      // },
      {
        input: `100~240VAC AC power supply`,
        size: "133mm * 76mm * 48mm",
        fre: "<div>4G：LTE-TDD：B34/B38/B39/B40/B41</div><div>TurMass：Low frequency (470MHz~510MHz) or high frequency</div>",
        download: "ba14e59a-cdd2-6666-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896www-03-xx.png",
        // src: prefix + "3c2bwe13-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "ba14e59a-cdd2-6666-99a5-19310964837b-01-en",
    //   },
    // },
  },
  {
    id: 12,
    title: "LoRa-Ethernet Gateway",
    keyFeatures: [
      "Heterogeneous Collaboration",
      "Free Networking",
      "Wide Temperature Applications ",
    ],
    features: [
      {
        info: "Low band or high band",
        subInfo: [],
      },
      {
        info: "Shell:IP65 waterproof and dustproof",
        subInfo: [],
      },
      {
        info: "Encrypted transmission",
        subInfo: [],
      },
      {
        info: "Embedded real-time operating system",
        subInfo: [],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `AC:220VAC`,
        PN: "<div>ZZHY2024110709 | ZZHY2024110709F</div>",
        size: "133mm * 75.89mm * 48.09mm",
        netrate: "10/100M",
        fre: "LoRa：410M～525MHz or 860～930MHz",
        LoRa_Receive_Sensitivity: "LoRa：-137 dBm@SF10 125KHz",
        download: "sn14e59a-cff2-6666-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-en",
    //   },
    // },
  },

  {
    id: 17,
    title: "Edge Processing Terminal",
    keyFeatures: [
      "Side-cloud Collaboration",
      "High-precision positioning",
      "Data processing",
      "Waterproof design",
    ],
    features: [
      {
        info: "4G LTE Cat-1",
        subInfo: [],
      },
      {
        info: "Standard configuration with metre-level positioning accuracy",
        subInfo: [],
      },
      {
        info: "RS485, 4~20mA detection, CAN bus interface",
        subInfo: [],
      },
      {
        info: "Contains a six-axis IMU and temperature and humidity sensors",
        subInfo: [],
      },
      {
        info: "Low power consumption design",
        subInfo: [],
      },
      {
        info: "Waterproof and dustproof",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: [
          "Smart Cities",
          "Smart Agriculture",
          "Smart Power",
          "Devices connect the Cloud",
        ],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・Internal battery power supply  </div>  <div>・External +12V power supply </div>  <div>・Powered by external solar panels</div>`,
        size: "158mm * 91mm * 56mm",
        rate_4g:
          "<div>・LTE-TDD：Max. 7.5Mbps(DL)/Max. 1Mbps(UL)</div> <div>・LTE-FDD：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cff2-6666-99a5-193109648399-01-en",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324499e10-03-xx.png",
      },
    ],
  },
  {
    id: 13,
    title: "Edge Processing Terminal (Small)",
    keyFeatures: [
      "Edge-cloud collaboration",
      "High-precision positioning",
      "Speech analysis",
    ],
    features: [
      {
        info: "LTE Cat-1",
        subInfo: [],
      },
      {
        info: "Standard configuration with metre-level positioning accuracy; high-end version supports decimetre to centimetre-level positioning accuracy.",
        subInfo: [],
      },
      {
        info: "Magnetic attachment or adhesive attachment",
        subInfo: [],
      },
      {
        info: "RS485, audio (external microphone can be connected)",
        subInfo: [],
      },
      {
        info: "Contains a six-axis IMU and temperature and humidity sensors",
        subInfo: [],
      },
      {
        info: "Low power consumption design",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Smart Construction Site", "Devices connect the Cloud"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・Internal battery power supply </div>  <div>・USB Type-C external power supply </div>`,
        size: "100mm * 62mm * 18mm",
        // rate_4g:
        //   "<div>・LTE-TDD：Max. 7.5Mbps(DL)/Max. 1Mbps(UL)</div> <div>・LTE-FDD：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cff2-7766-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324566e10-03-xx.png",
      },
    ],
  },
  {
    id: 18,
    title: "4G Voice Terminal Ⅰ",
    keyFeatures: ["Voice interaction", "Long Standby Time", "Small size"],
    features: [
      {
        info: "Voice Interaction, Making and Receiving Calls",
        subInfo: [],
      },
      {
        info: "Positioning accuracy: 2 metres",
        subInfo: [],
      },
      {
        info: "Low-Power Design",
        subInfo: [],
      },
      {
        info: "Built-in 6-axis IMU and magnetic sensor",
        subInfo: [],
      },
      {
        info: "Small size",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Smart Site", "Smart Power", "Park Positioning"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・Internal battery power supply  </div>  <div>・USB Type-C external power supply </div> `,
        size: "60mm * 97mm * 12mm",
        rate_4g:
          "<div>・LTE-TDD rate：Max. 8.96Mbps(DL)/Max. 3.1Mbps(UL)</div> <div>・LTE-FDD rate：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cdd2-6666-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "4412313-b963-43c4-a8a0-73c324566e10-03-xx.png",
      },
    ],
  },
  {
    id: 14,
    title: "4G Voice Terminal Ⅱ",
    keyFeatures: [
      "Voice interaction",
      "Ultra-low power",
      "Locate",
      "Waterproof design",
    ],
    features: [
      {
        info: "Voice Interaction, Making and Receiving Calls",
        subInfo: [],
      },
      {
        info: "Positioning accuracy: 2 metres",
        subInfo: [],
      },
      {
        info: "Outdoor waterproof design",
        subInfo: [],
      },
      {
        info: "Built-in 6-axis IMU and magnetic sensor",
        subInfo: [],
      },
      {
        info: "Low Power Design",
        subInfo: [],
      },
      {
        info: "Small Size",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: [
          "Smart Site",
          "Smart Power",
          "Safety Helmets",
          "Park Positioning",
        ],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>・Internal battery power supply </div>  <div>・USB Type-C external power supply</div>`,
        size: "38mm * 38mm * 18mm",
        rate_4g:
          "<div>・LTE-TDD：Max. 8.96Mbps(DL)/Max. 3.1Mbps(UL)</div> <div>LTE-FDD：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e5w3-cff2-6666-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c664566e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 16,
    title: "Electrical Parameter Monitoring Power Cord",
    keyFeatures: ["~10A/16A Current", "Highly Accurate", "Small Size"],
    features: [
      {
        info: "LTE Cat-1",
        subInfo: [],
      },
      {
        info: "High Accuracy",
        subInfo: [],
      },
      {
        info: "3C Certification",
        subInfo: [],
      },
      {
        info: "C13-C14/C19-C20",
        subInfo: [],
      },
      {
        info: "Application areas",
        subInfo: ["Facilities Management", "Data Centres", "Smart Hospital"],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>100~240 VAC</div>`,
        size: "50cm",
        rate_4g: "<div>LTE-TDD：Max. 7.5Mbps(DL)/Max. 1Mbps(UL)</div>",
        fre: "<div>・LTE-TDD：B34/B38/B39/B40/B41</div> <div>・LTE-FDD：B1/B3/B5/B8</div>",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e88a-cff2-6666-89a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "449bwe13-b963-43c4-a8a0-73c324896e10-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
  {
    id: 19,
    title: "Terminals For Current Monitoring",
    keyFeatures: ["~100A/120A/150A/200A", "high precision", "Low Power Design"],
    features: [
      {
        info: "High Precision",
        subInfo: [],
      },
      {
        info: "Long Lifespan",
        subInfo: [],
      },
      {
        info: "Upgradeable to support WiFi6",
        subInfo: [],
      },

      {
        info: "Application areas",
        subInfo: [
          "IoT For Electricity",
          "Facilities Management",
          "Smart Hospital",
        ],
      },
    ],
    name: "gateway",
    details: [
      {
        input: `<div>Internal battery power (19000mAh)</div>`,
        size: "43mm *43mm *136mm",
        // rate_4g:
        //   "<div>・LTE-TDD速率：Max. 8.96Mbps(DL)/Max. 3.1Mbps(UL)</div> <div>・LTE-FDD速率：Max. 10Mbps(DL)/Max. 5Mbps(UL)</div>",
        fre: "<div>2.4GHz</div> ",
        // LoRa_Receive_Sensitivity: "23dBm+/-2dB",
        download: "sn14e59a-cff2-diw6-99a5-19310964837b-01-en",
      },
    ],
    img: [
      {
        src: prefix + "219bwe13-b963-43c4-a8a0-73c324566e83-03-xx.png",
      },
    ],
    // download: {
    //   cn: {
    //     file_code: "sn14e59a-cff2-6666-99a5-19310964837b-01-cn",
    //   },
    // },
  },
];

export var serviceData_en = [
  {
    id: 1,
    title: "Circuit Design",
    keyFeatures: [],
    features: [
      {
        info: "Analog/Digital Circuit Design, PCB Layout, Prototyping Production, including:",
        subInfo: [
          "Embedded System (Including communication module)",
          "AC/DC power supply, DC/DC power supply",
          "Lithium battery energy storage system",
        ],
      },
      {
        info: "3D system modeling",
        subInfo: [],
      },
      {
        info: "Cost-effective, mass-producible BOM materials",
        subInfo: [],
      },
      {
        info: "Third party certification services(EMC, Safety and Reliability)",
        subInfo: [],
      },
      {
        info: "High density, compact design",
        subInfo: [],
      },
    ],
    name: "dianlu",
    details: [],
    img: [
      {
        src: prefix + "5b46c30d-4b0b-410b-b824-1281e3112aba-03-xx.jpg",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-en",
      },
    },
  },
  {
    id: 2,
    title: "Embedded Software Development",
    keyFeatures: [],
    features: [
      {
        info: "ARM Cortex-M series (e.g., STM32), including：",
        subInfo: [
          "ADC/DAC",
          "UART,I2C,SPI,CAN,RS-232,RS-485,U SB and other bus communication",
          "Real-time operating system FreeRTOS, RT-Thread, etc.",
          "FATFS file system",
        ],
      },
      {
        info: "ARM Cortex-A Series",
        subInfo: [],
      },
      {
        info: "Battery BMS algorithm",
        subInfo: [],
      },
      {
        info: "Lightweight deep neural network development",
        subInfo: [],
      },
      {
        info: "Over-the-Air Firmware Upgrade(FOTA)",
        subInfo: [],
      },
    ],
    name: "neptune",
    details: [],
    img: [
      {
        src: prefix + "6faa16f6-bf6f-483d-afc1-6c39ef1261a9-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-en",
      },
    },
  },
  {
    id: 3,
    title: "Mechanical design",
    keyFeatures: [],
    features: [
      {
        info: "ID Design",
        subInfo: [],
      },
      {
        info: "Complete machine design",
        subInfo: [],
      },
      {
        info: "2D/3D structural drawings",
        subInfo: [],
      },
      {
        info: "Stacking",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "c747d053-0baf-425e-8202-a72999054e6e-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-en",
      },
    },
  },
  {
    id: 4,
    title: "Desktop Application Development",
    keyFeatures: [
      "Cross Platform",
      "Multiple Communication Protocols BLE, WIFI, etc.",
      "Real-time Waveform Graph",
    ],
    features: [
      {
        info: "Cross-platform (Windows, Linux, MacOs)",
        subInfo: [],
      },
      {
        info: "AI Algorithm",
        subInfo: [],
      },
      {
        info: "Free addition and subtraction of modules",
        subInfo: [],
      },
      {
        info: "Adaptive Layout",
        subInfo: [],
      },
      {
        info: "Multiple Communication Protocols BLE, WIFI",
        subInfo: [],
      },
      {
        info: "Embedded Database",
        subInfo: [],
      },
      {
        info: "Exquisite UI Design",
        subInfo: [],
      },
      {
        info: "Automatic Report Generation ",
        subInfo: [],
      },
      {
        info: "OTA Upgrade",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "777c112b-83ca-4acf-8a98-4947ab5524da-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "91dc746c-3c01-437e-a6e1-e1ddc932d9ce-01-en",
      },
    },
  },
  {
    id: 5,
    title: "Front-end Development",
    keyFeatures: [
      "Front-end Development",
      "Big Data Screen",
      "Professional UI Design",
    ],
    features: [
      {
        info: "Real-time",
        subInfo: [],
      },
      {
        info: "Omni-directional",
        subInfo: [],
      },
      {
        info: "Compatibility",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "7d0dd728-23fa-4e01-9e94-234809b8be78-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "a73372b9-7df0-46bc-b989-00131aa87380-01-en",
      },
    },
  },
  {
    id: 6,
    title: "Data Analysis",
    keyFeatures: [],
    features: [
      {
        info: "Mathematical Statistics",
        subInfo: [],
      },
      {
        info: "Data Modeling",
        subInfo: [],
      },
      {
        info: "Data Mining",
        subInfo: [],
      },
      {
        info: "Machine Learning",
        subInfo: [],
      },
      {
        info: "Big Data Analysis",
        subInfo: [],
      },
    ],
    name: "IOTsystem",
    details: [],
    img: [
      {
        src: prefix + "390147f2-6115-42d6-9be8-0300ddb473ef-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "a73372b9-7df0-46bc-b989-00131aa87380-01-cn",
      },
    },
  },
  {
    id: 7,
    title: "Edge Computing Gateway",
    keyFeatures: [
      "AI computing",
      "Edge-cloud Collaboration",
      "High Reliability",
    ],
    features: [
      {
        info: "AI algorithm",
        subInfo: [],
      },
      {
        info: "Linux system",
        subInfo: [],
      },
      {
        info: "Support mainstream target detection and image recognition algorithms",
        subInfo: [],
      },
      {
        info: "Algorithmic deliveried from Cloud",
        subInfo: [],
      },
      {
        info: "4G、5G、Zigbee、LoRa",
        subInfo: [],
      },
      {
        info: "Supports the industry's leading deep learning computing frameworks",
        subInfo: [],
      },
      {
        info: "Support for Docker Deployment",
        subInfo: [],
      },
      {
        info: "Task scheduling",
        subInfo: [],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "4c40bf6d-c04e-4249-a032-e46e211www3c-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "0e9040b9-1a64-4982-a246-91356ed928b9-01-en",
      },
    },
  },
  {
    id: 8,
    title: "Interaction Design",
    keyFeatures: [],
    features: [
      {
        info: "Serial screen and SPI screen",
        subInfo: [],
      },
      {
        info: "UI, UE",
        subInfo: [],
      },
      {
        info: "Configuration Development",
        subInfo: [],
      },
    ],
    name: "",
    details: [],
    img: [
      {
        src: prefix + "c747d053-0baf-425e-8202-a729dc054e6e-03-xx.png",
      },
    ],
    download: {
      cn: {
        file_code: "c51f5f07-d50d-4ea4-aa28-4b47524d7a10-01-en",
      },
    },
  },
];

export const getProductByName = function (name, en_or_cn = "cn") {
  if (en_or_cn === "cn")
    return productData.find((element) => element.title === name);
  if (en_or_cn === "en")
    return productData_en.find((element) => element.title === name);
};

export const getServiceByName = function (name, en_or_cn = "cn") {
  if (en_or_cn === "cn")
    return serviceData.find((element) => element.title === name);
  if (en_or_cn === "en")
    return serviceData_en.find((element) => element.title === name);
};
